import React from 'react';
import {HelpSidePanelContent} from './help-side-panel';

export const HELP_CONTENTS = {
    EMPTY: {} as HelpSidePanelContent,
    INBOUND_BRIDGE_HORIZON: {
        header: <>Understanding Horizon</>,
        body: (
            <div>
                <p>
                    A Horizon setting determines which historical plans are used in the bridging. All plans are captured every
                    Tuesday.
                    <br />
                    <li>T+X Week means: use plans from X weeks ago</li>
                    <li>Plans are always captured on Tuesdays</li>
                    <li>Different dates in your selection may use different plans</li>
                    <br />
                    <br />
                    <b>Example 1:</b> Single Date Selection: When you select Wednesday Oct 29, 2025 with Horizon T+1 Week, system
                    uses plans from up to Tuesday Oct 21, 2025
                    <br />
                    <br />
                    <b>Example 2:</b> Date Range Selection: When you select Oct 25-26, 2025 with Horizon T+1 Week, for Oct 26: it
                    uses plans from up to Tuesday Oct 21, 2025, and for Oct 25: uses plans from up to Tuesday Oct 14, 2025
                </p>
            </div>
        ),
    } as HelpSidePanelContent,
    INBOUND_BRIDGE_BUCKETS: {
        header: <>Understanding Buckets</>,
        body: (
            <div>
                <a
                    href="https://w.amazon.com/bin/view/F3/F3_Grocery_Supply_Chain/Sales_And_Operations_Planning/Team_GROOT/Spoke_IB_Bridge/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Inbound Bridge Documentation
                </a>
            </div>
        ),
    } as HelpSidePanelContent,
} as const;
